// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    scopeId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    scopeId: z.string().min(1).max(21),
});
export const CimdResourceScopes = Object.freeze({
    table: 'cimd_resource_scopes',
    tableSingular: 'cimd_resource_scope',
    fields: {
        tenantId: 'tenant_id',
        scopeId: 'scope_id',
    },
    fieldKeys: [
        'tenantId',
        'scopeId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
